import { render, staticRenderFns } from "./listVideos.vue?vue&type=template&id=90cf6342&"
import script from "./listVideos.vue?vue&type=script&lang=js&"
export * from "./listVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports